<div class="container-fluid">
  <!-- start page title -->
  <app-pagetitle title="Machine" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
  <!-- end page title -->

  <div class="row d-flex justify-content-between mr-1 ml-1">
    <div class="justify-content-start">
      <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchTerm" />
    </div>
    <div class="mt-1 justify-content-end" *ngIf="!isEdit">
      <button
        *ngIf="loginRole == 'SUPERADMIN' && machineTypeList.length != 0"
        class="btn btn-primary"
        (click)="adddevice()"
      >
        Add Device
      </button>
      &nbsp;
      <button *ngIf="loginRole == 'SUPERADMIN'" class="btn btn-primary" (click)="openModal(machineType, 'Add')">
        Add Machine Type
      </button>
      <button
        *ngIf="loginRole == 'SUPERADMIN'"
        class="btn btn-primary mt-1 mt-sm-0 ml-sm-2"
        (click)="openFormula()"
      >
        Formula
      </button>
      <button 
         *ngIf="loginRole == 'SUPERADMIN'"
        class="btn btn-primary mt-1 mt-sm-0 ml-sm-2"
        (click)="openProcessMasterlist()"
      >
        Process
      </button>
        <button
        *ngIf="loginRole == 'SUPERADMIN'"
        class="btn btn-primary mt-1 mt-sm-0 ml-sm-2"
        (click)="openCategory()"
      >
        Interlock Category
      </button>
    </div>
  </div>

  <!-- Device List Table -->
  <div class="row mt-2" *ngIf="deviceList.length != 0 && !isAdd">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-striped table-bordered table-centered datatable dt-responsive nowrap mb-0">
              <thead class="table-dark">
                <tr>
                  <th>Machine Name</th>
                  <th>Machine Id</th>
                  <th>Machine Model</th>
                  <th>Machine Type</th>
                  <th>Licensing</th>
                  <th style="width: 120px">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let item of deviceList | filter: searchTerm | slice: pageSize | slice: 0:itemsPerPage;
                    let i = index
                  "
                >
                  <th scope="row">{{ item.deviceName ? item.deviceName : "-" }}</th>
                  <td>{{ item.deviceId ? item.deviceId : "-" }}</td>
                  <td>{{ item.deviceModelNo ? item.deviceModelNo : "-" }}</td>
                  <td>{{ item.meterSupplier ? item.meterSupplier : "-" }}</td>
                  <td>{{ item.licensing ? item.licensing : "-" }}</td>
                  <td>
                    <a class="mr-3 text-primary" title="Edit">
                      <i class="mdi mdi-pencil font-size-18" style="cursor: pointer" (click)="edit(item)"></i>
                    </a>
                    <a [hidden]="loginRole == 'CUSTOMER'" class="text-danger" title="Delete">
                      <i
                        class="mdi mdi-trash-can font-size-18"
                        style="cursor: pointer"
                        (click)="openModalDelete(deletetemp, item.id, item)"
                      ></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="col-md-6" *ngIf="deviceList?.length > 5">
              <ngb-pagination
                class="pagination-rounded"
                [collectionSize]="deviceList?.length"
                [pageSize]="itemsPerPage"
                [(page)]="currentPage"
                [maxSize]="1"
                [rotate]="true"
                [ellipses]="false"
                [boundaryLinks]="true"
                (pageChange)="onPageChange(currentPage)"
              ></ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Device Add/Edit Form -->
  <div class="row mt-2" *ngIf="isAdd">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row d-flex justify-content-between">
            <h4 class="card-title">Machine Configuration</h4>
            <button type="button" class="close mr-3" aria-label="Close" (click)="cancel()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form (ngSubmit)="typeSubmit()" [formGroup]="deviceForm">

            <!-- ─── Basic Fields ─── -->
            <div class="row">
              <!-- Device ID -->
              <div class="form-group col-md-6">
                <label>Device ID</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="deviceId"
                  [ngClass]="{ 'is-invalid': typesubmit && type.deviceId.errors }"
                  placeholder="348518678A68"
                />
                <div *ngIf="typesubmit && type.deviceId.errors" class="invalid-feedback">
                  <span *ngIf="type.deviceId.errors.required">This value is required.</span>
                  <span *ngIf="type.deviceId.errors.maxlength">Maximum length exceeded (maximum: 12 characters).</span>
                </div>
              </div>

              <!-- Machine Name -->
              <div class="form-group col-md-6">
                <label>Machine Name</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="deviceName"
                  [ngClass]="{ 'is-invalid': typesubmit && type.deviceName.errors }"
                  placeholder="Robo_Welding"
                />
                <div *ngIf="typesubmit && type.deviceName.errors" class="invalid-feedback">
                  <span *ngIf="type.deviceName.errors.required">This value is required.</span>
                </div>
              </div>

              <!-- Machine Type -->
              <div class="form-group col-md-6">
                <label for="deviceType">Machine Type</label>
                <select
                  id="deviceType"
                  class="form-control"
                  formControlName="deviceType"
                  [ngClass]="{ 'is-invalid': typesubmit && type.deviceType.errors }"
                  (change)="ondeviceTypeChange($event)"
                >
                  <option value="" disabled selected>Select Machine Type</option>
                  <option *ngFor="let devType of machineTypeList" [value]="devType">{{ devType }}</option>
                </select>
                <div *ngIf="typesubmit && type.deviceType.errors" class="invalid-feedback">
                  Please select a machine type.
                </div>
              </div>

              <!-- Department -->
              <div class="form-group col-md-6">
                <label for="departmentName">Department</label>
                <select
                  id="departmentName"
                  class="form-control"
                  formControlName="departmentName"
                  [ngClass]="{ 'is-invalid': typesubmit && type.departmentName.errors }"
                >
                  <option value="" disabled selected>Select Department</option>
                  <option *ngFor="let department of departmentData" [value]="department.departmentName">
                    {{ department.departmentName }}
                  </option>
                </select>
                <div *ngIf="typesubmit && type.departmentName.errors" class="invalid-feedback">
                  Please select a Department Name.
                </div>
              </div>

              <!-- Machine Model Number -->
              <div class="form-group col-md-6">
                <label>Machine Model Number</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="deviceModelNo"
                  [ngClass]="{ 'is-invalid': typesubmit && type.deviceModelNo.errors }"
                  placeholder="Machine_Model_Number"
                />
                <div *ngIf="typesubmit && type.deviceModelNo.errors" class="invalid-feedback">
                  <span *ngIf="type.deviceModelNo.errors.required">This value is required.</span>
                </div>
              </div>

              <!-- Machine Controller -->
              <div class="form-group col-md-6">
                <label>Machine Controller</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="deviceController"
                  [ngClass]="{ 'is-invalid': typesubmit && type.deviceController.errors }"
                  placeholder="Machine_Controller"
                />
                <div *ngIf="typesubmit && type.deviceController.errors" class="invalid-feedback">
                  <span *ngIf="type.deviceController.errors.required">This value is required.</span>
                </div>
              </div>

              <!-- Machine Manufacture -->
              <div class="form-group col-md-6">
                <label>Machine Manufacture</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="deviceMake"
                  [ngClass]="{ 'is-invalid': typesubmit && type.deviceMake.errors }"
                  placeholder="Machine_Manufacture"
                />
                <div *ngIf="typesubmit && type.deviceMake.errors" class="invalid-feedback">
                  <span *ngIf="type.deviceMake.errors.required">This value is required.</span>
                </div>
              </div>

              <!-- Machine Supplier -->
              <div class="form-group col-md-6">
                <label>Machine Supplier</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="devicesupplier"
                  [ngClass]="{ 'is-invalid': typesubmit && type.devicesupplier.errors }"
                  placeholder="Machine_Supplier"
                />
                <div *ngIf="typesubmit && type.devicesupplier.errors" class="invalid-feedback">
                  <span *ngIf="type.devicesupplier.errors.required">This value is required.</span>
                </div>
              </div>

              <!-- Machine Age -->
              <div class="form-group col-md-6">
                <label>Machine Age (Years)</label>
                <input
                  type="number"
                  class="form-control"
                  formControlName="deviceage"
                  [ngClass]="{ 'is-invalid': typesubmit && type.deviceage.errors }"
                  placeholder="5"
                />
                <div *ngIf="typesubmit && type.deviceage.errors" class="invalid-feedback">
                  <span *ngIf="type.deviceage.errors.required">This value is required.</span>
                  <span *ngIf="type.deviceage.errors.maxDigits">Maximum length exceeded (maximum: 3 digits).</span>
                </div>
              </div>

              <!-- Cost Per Hour -->
              <div class="form-group col-md-6">
                <label>Machine Cost Per Hour</label>
                <input
                  type="number"
                  class="form-control"
                  formControlName="costperHour"
                  [ngClass]="{ 'is-invalid': typesubmit && type.costperHour.errors }"
                  placeholder="123"
                />
                <div *ngIf="typesubmit && type.costperHour.errors" class="invalid-feedback">
                  <span *ngIf="type.costperHour.errors.required">This value is required.</span>
                </div>
              </div>

              <!-- Current Load -->
              <div class="form-group col-md-6">
                <label>Current Load [ amps ]</label>
                <input
                  type="number"
                  class="form-control"
                  formControlName="current"
                  [ngClass]="{ 'is-invalid': typesubmit && type.current.errors }"
                  placeholder="0"
                />
                <div *ngIf="typesubmit && type.current.errors" class="invalid-feedback">
                  <span *ngIf="type.current.errors.required">This value is required.</span>
                  <span *ngIf="type.current.errors.maxDigits">Maximum length exceeded (maximum: 3 digits).</span>
                </div>
              </div>

              <!-- Power Factor -->
              <div class="form-group col-md-6">
                <label>Power Factor</label>
                <input
                  type="number"
                  class="form-control"
                  formControlName="powerfactor"
                  [ngClass]="{ 'is-invalid': typesubmit && type.powerfactor.errors }"
                  placeholder="0.9"
                />
                <div *ngIf="typesubmit && type.powerfactor.errors" class="invalid-feedback">
                  <span *ngIf="type.powerfactor.errors.required">This value is required.</span>
                  <span *ngIf="type.powerfactor.errors.maxDigits">Maximum length exceeded (maximum: 3 digits).</span>
                </div>
              </div>

              <!-- Number of Axis (CNC only) -->
              <div class="form-group col-md-6" *ngIf="deviceForm.get('deviceType')?.value == 'CNC'">
                <label>Number of Axis</label>
                <input
                  type="number"
                  class="form-control"
                  formControlName="axis"
                  [ngClass]="{ 'is-invalid': typesubmit && type.axis.errors }"
                  placeholder="3"
                />
                <div *ngIf="typesubmit && type.axis.errors" class="invalid-feedback">
                  <span *ngIf="type.axis.errors.required">This value is required.</span>
                  <span *ngIf="type.axis.errors.maxDigits">Maximum length exceeded (maximum: 3 digits).</span>
                </div>
              </div>

              <!-- Number of Spindle (CNC only) -->
              <div class="form-group col-md-6" *ngIf="deviceForm.get('deviceType')?.value == 'CNC'">
                <label>Number of Spindle</label>
                <input
                  type="number"
                  class="form-control"
                  formControlName="spindle"
                  [ngClass]="{ 'is-invalid': typesubmit && type.spindle.errors }"
                  placeholder="1"
                />
                <div *ngIf="typesubmit && type.spindle.errors" class="invalid-feedback">
                  <span *ngIf="type.spindle.errors.required">This value is required.</span>
                  <span *ngIf="type.spindle.errors.maxDigits">Maximum length exceeded (maximum: 3 digits).</span>
                </div>
              </div>

              <!-- Input Voltage -->
              <div class="form-group col-md-6">
                <label>Input Voltage [ V ]</label>
                <input
                  type="number"
                  class="form-control"
                  formControlName="voltage"
                  [ngClass]="{ 'is-invalid': typesubmit && type.voltage.errors }"
                  placeholder="230"
                />
                <div *ngIf="typesubmit && type.voltage.errors" class="invalid-feedback">
                  <span *ngIf="type.voltage.errors.required">This value is required.</span>
                  <span *ngIf="type.voltage.errors.maxDigits">Maximum length exceeded (maximum: 3 digits).</span>
                </div>
              </div>

              <!-- OEE Calculation -->
              <div class="form-group col-md-6">
                <label>OEE Calculation</label>
                <select
                  class="form-control"
                  formControlName="oee"
                  [ngClass]="{ 'is-invalid': typesubmit && type.oee.errors }"
                  (change)="onOEEChange($event)"
                >
                  <option value="" disabled selected>Select OEE</option>
                  <option value="parts">With Target Part</option>
                  <option value="no_part">Without Part</option>
                  <option value="cycletime">With CycleTime</option>
                </select>
                <div *ngIf="typesubmit && type.oee.errors" class="text-danger">
                  Please select an OEE Configuration.
                </div>
              </div>

              <!-- Licensing -->
              <div class="form-group col-md-6">
                <label>Licensing</label>
                <select class="form-control" formControlName="licensing">
                  <option value="3">3 months</option>
                  <option value="6">6 months</option>
                  <option value="12">12 months</option>
                  <option value="18">18 months</option>
                  <option value="24">24 months</option>
                  <option value="30">30 months</option>
                  <option value="36">36 months</option>
                </select>
              </div>

              <!-- Device Manufacture -->
              <div class="form-group col-md-6">
                <label>Device Manufacture</label>
                <select
                  class="form-control"
                  formControlName="meterSupplier"
                  [ngClass]="{ 'is-invalid': typesubmit && type.meterSupplier.errors }"
                  (change)="onMeterChange($event.target.value)"
                >
                  <!-- <option value="Selec">Selec</option>
                  <option value="Multispan">Multispan</option> -->
                  <option value="Wimera-K2">Wimera-K2</option>
                  <!-- <option value="Wimera-Remon">Wimera-Remon</option>
                  <option value="Remon_2024">Remon_2024</option> -->
                  <option value="K2-V1.1">K2-V1.1</option>
                </select>
                <div *ngIf="typesubmit && type.meterSupplier.errors" class="text-danger">
                  Please select a Device Manufacture.
                </div>
              </div>

              <!-- Device Model — Selec -->
              <div class="form-group col-md-6" *ngIf="deviceForm.get('meterSupplier')?.value == 'Selec'">
                <label>Device Model</label>
                <select
                  class="form-control"
                  formControlName="meterModel"
                  [ngClass]="{ 'is-invalid': typesubmit && type.meterModel.errors }"
                >
                  <option value="EM2M">EM2M</option>
                  <option value="EM4M">EM4M</option>
                </select>
                <div *ngIf="typesubmit && type.meterModel.errors" class="text-danger">Please select a Device Model.</div>
              </div>

              <!-- Device Model — Multispan -->
              <div class="form-group col-md-6" *ngIf="deviceForm.get('meterSupplier')?.value == 'Multispan'">
                <label>Device Model</label>
                <select
                  class="form-control"
                  formControlName="meterModel"
                  [ngClass]="{ 'is-invalid': typesubmit && type.meterModel.errors }"
                >
                  <option value="MFM-13-W">MFM-13-W</option>
                  <option value="AVH-16-W">AVH-16-W</option>
                </select>
                <div *ngIf="typesubmit && type.meterModel.errors" class="text-danger">Please select a Device Model.</div>
              </div>

              <!-- Device Model — Wimera-K2 -->
              <div class="form-group col-md-6" *ngIf="deviceForm.get('meterSupplier')?.value == 'Wimera-K2'">
                <label>Device Model</label>
                <select
                  class="form-control"
                  formControlName="meterModel"
                  [ngClass]="{ 'is-invalid': typesubmit && type.meterModel.errors }"
                >
                  <option value="Wim-1010">Wim-1010</option>
                </select>
                <div *ngIf="typesubmit && type.meterModel.errors" class="text-danger">Please select a Device Model.</div>
              </div>

              <!-- Device Model — Wimera-Remon / Remon_2024 -->
              <div
                class="form-group col-md-6"
                *ngIf="
                  deviceForm.get('meterSupplier')?.value == 'Wimera-Remon' ||
                  deviceForm.get('meterSupplier')?.value == 'Remon_2024'
                "
              >
                <label>Device Model</label>
                <select
                  class="form-control"
                  formControlName="meterModel"
                  [ngClass]="{ 'is-invalid': typesubmit && type.meterModel.errors }"
                >
                  <option value="Wim-82A">Wim-82A</option>
                </select>
                <div *ngIf="typesubmit && type.meterModel.errors" class="text-danger">Please select a Device Model.</div>
              </div>

              <!-- Device Model — K2-V1.1 -->
              <div class="form-group col-md-6" *ngIf="deviceForm.get('meterSupplier')?.value == 'K2-V1.1'">
                <label>Device Model</label>
                <select
                  class="form-control"
                  formControlName="meterModel"
                  [ngClass]="{ 'is-invalid': typesubmit && type.meterModel.errors }"
                >
                  <option value="WIM_1011">WIM_1011</option>
                </select>
                <div *ngIf="typesubmit && type.meterModel.errors" class="text-danger">Please select a Device Model.</div>
              </div>

              <!-- Connection Type -->
              <div class="form-group col-md-6">
                <label>Connection Type</label>
                <select
                  class="form-control"
                  formControlName="connectionType"
                  [ngClass]="{ 'is-invalid': typesubmit && type.connectionType.errors }"
                >
                  <option value="1P-2W">1P-2W</option>
                  <option value="2P-3W">2P-3W</option>
                  <option value="3P-3W">3P-3W</option>
                  <option value="3P-4W">3P-4W</option>
                </select>
                <div *ngIf="typesubmit && type.connectionType.errors" class="text-danger">
                  Please select a Connection Type.
                </div>
              </div>

              <!-- Part Count Type (hidden when no_part) -->
              <div class="form-group col-md-6" *ngIf="deviceForm.get('oee')?.value != 'no_part'">
                <label>Part Count Type</label>
                <select
                  class="form-control"
                  formControlName="partcountType"
                  [ngClass]="{ 'is-invalid': typesubmit && type.partcountType.errors }"
                  (change)="onpartTypeChange($event)"
                >
                  <option value="" disabled selected>Select Part Count Type</option>
                  <option *ngFor="let type of filteredPartcountTypes" [value]="type.value">
                    {{ type.label }}
                  </option>
                </select>
                <div *ngIf="typesubmit && type.partcountType.errors" class="text-danger">
                  Please select a Part Count Type.
                </div>
              </div>
            </div>

            <hr />

            <!-- ─── Pin Configuration (digital only) ─── -->
            <div
              class="form-group col-md-6"
              *ngIf="deviceForm.get('partcountType')?.value == 'digital'"
              [hidden]="loginRole == 'CUSTOMER' && deviceForm.get('pins')['controls'].length == 0"
            >
              <h4 class="card-title">
                Pin Configuration
                <span style="position: absolute; margin-left: 2%">
                  <i
                    class="fas fa-plus-circle"
                    *ngIf="showDigitalPinAddButton"
                    (click)="addDigitalPin()"
                    style="color: rgb(72, 255, 0); cursor: pointer; margin-left: 10px"
                    title="Add"
                  ></i>
                </span>
              </h4>
            </div>

            <div formArrayName="pins">
              <div
                class="row"
                *ngFor="let pin of deviceForm.get('pins')['controls']; let i = index"
                [formGroupName]="i"
              >
                <div class="form-group col-md-1">
                  <label>Index</label>
                  <input type="number" class="form-control" formControlName="index" placeholder="0" />
                </div>
                <div class="form-group col-md-3">
                  <label>Pin Name</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="pinName"
                    placeholder="PIN1"
                    [ngClass]="{ 'is-invalid': typesubmit && deviceForm.get('pins.' + i + '.pinName')?.errors }"
                  />
                  <div
                    *ngIf="typesubmit && deviceForm.get('pins.' + i + '.pinName')?.errors"
                    class="invalid-feedback"
                  >
                    Pin Name is required.
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label>Pin Type</label>
                  <select class="form-control" formControlName="pinType">
                    <option value="none">None</option>
                    <option value="status">Status</option>
                    <option value="counter">Counter</option>
                  </select>
                </div>
                <div class="form-group col-md-3">
                  <label>Part Config</label>
                  <select class="form-control" formControlName="partConfig">
                    <option [ngValue]="true">true</option>
                    <option [ngValue]="false">false</option>
                  </select>
                </div>
                <i
                  class="fas fa-minus-circle col-md-1"
                  [hidden]="loginRole == 'CUSTOMER' || i === 0 || deviceForm.get('pins')['controls'].length <= 1"
                  style="color: red; cursor: pointer; margin-top: 2.5rem"
                  title="Remove"
                  (click)="removeArrayItem(i)"
                ></i>
              </div>
            </div>

            <hr />

            <!-- ─── In Pin Configuration (K2-V1.1 only) ─── -->
            <ng-container *ngIf="deviceForm.get('meterSupplier')?.value == 'K2-V1.1'">
              <div
                class="form-group col-md-6"
                [hidden]="loginRole == 'CUSTOMER' && deviceForm.get('inpins')['controls'].length == 0"
              >
                <h4 class="card-title">In Pin Configuration</h4>
              </div>
              <div formArrayName="inpins">
                <div
                  class="row"
                  *ngFor="let pin of deviceForm.get('inpins')['controls']; let i = index"
                  [formGroupName]="i"
                >
                  <div class="form-group col-md-1">
                    <label>Index</label>
                    <input type="number" class="form-control" formControlName="index" />
                  </div>
                  <div class="form-group col-md-3">
                    <label>In Pin Status</label>
                    <select class="form-control" formControlName="inpinStatus">
                      <option value="0">Disable</option>
                      <option value="1">Enable</option>
                    </select>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Scan Frequency</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="inpinScanFrequency"
                      placeholder="0"
                      [ngClass]="{
                        'is-invalid': typesubmit && deviceForm.get('inpins.' + i + '.inpinScanFrequency')?.errors
                      }"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label>Post Frequency</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="inpinPostFrequency"
                      placeholder="0"
                      [ngClass]="{
                        'is-invalid': typesubmit && deviceForm.get('inpins.' + i + '.inpinPostFrequency')?.errors
                      }"
                    />
                  </div>
                </div>
              </div>
            </ng-container>

            <hr />

            <!-- ─── Out Pin Configuration (K2-V1.1 only) ─── -->
            <ng-container *ngIf="deviceForm.get('meterSupplier')?.value == 'K2-V1.1'">
              <div
                class="form-group col-md-6"
                [hidden]="loginRole == 'CUSTOMER' && deviceForm.get('outpins')['controls'].length == 0"
              >
                <h4 class="card-title">
                  Out Pin Configuration
                  <span style="position: absolute; margin-left: 2%">
                    <i
                      class="fas fa-plus-circle"
                      *ngIf="deviceForm.get('outpins')['controls'].length < 2"
                      (click)="addoutpins()"
                      [hidden]="loginRole == 'CUSTOMER'"
                      style="color: rgb(72, 255, 0); cursor: pointer; margin-left: 10px"
                      title="Add"
                    ></i>
                  </span>
                </h4>
              </div>
              <div formArrayName="outpins">
                <div
                  class="row"
                  *ngFor="let pin of deviceForm.get('outpins')['controls']; let i = index"
                  [formGroupName]="i"
                >
                  <div class="form-group col-md-1">
                    <label>Index</label>
                    <input type="number" class="form-control" formControlName="index" />
                  </div>
                  <div class="form-group col-md-3">
                    <label>Out Pin Status</label>
                    <select class="form-control" formControlName="outpinStatus">
                      <option value="0">Disable</option>
                      <option value="1">Enable</option>
                    </select>
                  </div>
                  <div class="form-group col-md-3">
                    <label>Time Duration</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="outpinTimeDuration"
                      placeholder="0"
                      [ngClass]="{
                        'is-invalid': typesubmit && deviceForm.get('outpins.' + i + '.outpinTimeDuration')?.errors
                      }"
                    />
                  </div>
                  <i
                    class="fas fa-minus-circle col-md-1"
                    [hidden]="loginRole == 'CUSTOMER' || deviceForm.get('outpins')['controls'].length === 1"
                    style="color: red; cursor: pointer; margin-top: 2.5rem"
                    title="Remove"
                    (click)="removeoutpinItem(i)"
                  ></i>
                </div>
              </div>
            </ng-container>

            <hr />

            <!-- ─── Analog Configuration ─── -->
            <div
              class="form-group col-md-6"
              [hidden]="loginRole == 'CUSTOMER' && deviceForm.get('analog')['controls'].length == 0"
            >
              <h4 class="card-title">
                Analog Configuration
                <span style="position: absolute; margin-left: 2%">
                  <i
                    class="fas fa-plus-circle"
                    *ngIf="deviceForm.get('analog')['controls'].length < 4"
                    (click)="addAnalogPin()"
                    [hidden]="loginRole == 'CUSTOMER'"
                    style="color: rgb(72, 255, 0); cursor: pointer; margin-left: 10px"
                    title="Add"
                  ></i>
                </span>
              </h4>
            </div>

            <div class="row">
              <div class="form-group col-md-3">
                <label>Scan Frequency</label>
                <input type="number" class="form-control" formControlName="analogscanFreq" placeholder="Scan Frequency" />
              </div>
              <div class="form-group col-md-3">
                <label>Post Frequency</label>
                <input type="number" class="form-control" formControlName="analogpostFreq" placeholder="Post Frequency" />
              </div>
            </div>

            <div formArrayName="analog">
              <div
                class="row"
                *ngFor="let analog of deviceForm.get('analog')['controls']; let i = index"
                [formGroupName]="i"
              >
                <div class="form-group col-md-1">
                  <label>Index</label>
                  <input type="number" class="form-control" formControlName="index" />
                </div>
                <div class="form-group col-md-2">
                  <label>Analog Name</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="analogName"
                    placeholder="Name"
                    [ngClass]="{ 'is-invalid': typesubmit && deviceForm.get('analog.' + i + '.analogName')?.errors }"
                  />
                </div>
                <div class="form-group col-md-2">
                  <label>Channel</label>
                  <select class="form-control" formControlName="channel">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                  </select>
                </div>
                <div class="form-group col-md-2">
                  <label>Pin Type</label>
                  <select class="form-control" formControlName="portType">
                    <option value="voltage">Voltage</option>
                    <option value="current">4-20mA</option>
                    <option value="CT">CT</option>
                    <option value="None">None</option>
                  </select>
                </div>

                <!-- Voltage-specific fields -->
                <div class="form-group col-md-2" *ngIf="deviceForm.get('analog.' + i + '.portType')?.value === 'voltage'">
                  <label>Multiple Factor</label>
                  <input type="number" class="form-control" formControlName="multiFactor" placeholder="0" />
                </div>
                <div class="form-group col-md-2" *ngIf="deviceForm.get('analog.' + i + '.portType')?.value === 'voltage'">
                  <label>Division Factor</label>
                  <input type="number" class="form-control" formControlName="divisionFactor" placeholder="0" />
                </div>

                <!-- Current/None-specific fields -->
                <div
                  class="form-group col-md-2"
                  *ngIf="
                    deviceForm.get('analog.' + i + '.portType')?.value === 'current' ||
                    deviceForm.get('analog.' + i + '.portType')?.value === 'None'
                  "
                >
                  <label>Lower Limit</label>
                  <input type="number" class="form-control" formControlName="lowerLimit" placeholder="0" />
                </div>
                <div
                  class="form-group col-md-2"
                  *ngIf="
                    deviceForm.get('analog.' + i + '.portType')?.value === 'current' ||
                    deviceForm.get('analog.' + i + '.portType')?.value === 'None'
                  "
                >
                  <label>Upper Limit</label>
                  <input type="number" class="form-control" formControlName="upperLimit" placeholder="0" />
                </div>

                <!-- CT-specific fields -->
                <div class="form-group col-md-2" *ngIf="deviceForm.get('analog.' + i + '.portType')?.value === 'CT'">
                  <label>CT Ratio</label>
                  <input type="number" class="form-control" formControlName="ctRatio" placeholder="0" />
                </div>
                <div class="form-group col-md-2" *ngIf="deviceForm.get('analog.' + i + '.portType')?.value === 'CT'">
                  <label>Scale Factor</label>
                  <input type="number" class="form-control" formControlName="scaleFactor" placeholder="0" />
                </div>

                <!-- Sensor Output Type -->
                <div class="form-group col-md-2">
                  <label>Sensor Output Type</label>
                  <select class="form-control" formControlName="sensorOutputType" (change)="updateValue(i)">
                    <option value="-1">None</option>
                    <option value="0">ADC_RAW</option>
                    <option value="1">ADC_VMAX</option>
                    <option value="2">ADC_VMIN</option>
                    <option value="3">ADC_VPP</option>
                    <option value="4">ADC_VP</option>
                    <option value="5">ADC_VRMS</option>
                    <option value="6">ADC_VAVG</option>
                  </select>
                </div>

                <i
                  class="fas fa-minus-circle col-md-1"
                  [hidden]="loginRole == 'CUSTOMER' || deviceForm.get('analog')['controls'].length === 1"
                  style="color: red; cursor: pointer; margin-top: 2.5rem"
                  title="Remove"
                  (click)="removeAnalogItem(i)"
                ></i>
              </div>
            </div>

            <hr />

            <!-- ─── Pin Debounce Frequency ─── -->
            <div class="form-group col-md-6">
              <h4 class="card-title">Pin Debounce Frequency</h4>
            </div>
            <div formArrayName="pindebounce">
              <div
                class="row"
                *ngFor="let pin of deviceForm.get('pindebounce')['controls']; let i = index"
                [formGroupName]="i"
              >
                <div class="form-group col-md-1">
                  <label>Index</label>
                  <input type="number" class="form-control" formControlName="index" />
                </div>
                <div class="form-group col-md-2">
                  <label>IO1</label>
                  <input type="number" class="form-control" formControlName="io1" placeholder="0" />
                </div>
                <div class="form-group col-md-2">
                  <label>IO2</label>
                  <input type="number" class="form-control" formControlName="io2" placeholder="0" />
                </div>
                <div class="form-group col-md-2">
                  <label>IO3</label>
                  <input type="number" class="form-control" formControlName="io3" placeholder="0" />
                </div>
                <div class="form-group col-md-2">
                  <label>IO4</label>
                  <input type="number" class="form-control" formControlName="io4" placeholder="0" />
                </div>
              </div>
            </div>

            <hr />

            <!-- ─── Status Derivation / CT (K2-V1.1 only) ─── -->
            <ng-container *ngIf="deviceForm.get('meterSupplier')?.value == 'K2-V1.1'">
              <div
                class="form-group col-md-6"
                [hidden]="loginRole == 'CUSTOMER' && deviceForm.get('ct')['controls'].length == 0"
              >
                <h4 class="card-title">Status Derivation</h4>
              </div>
              <div formArrayName="ct">
                <div
                  class="row"
                  *ngFor="let ct of deviceForm.get('ct')['controls']; let i = index"
                  [formGroupName]="i"
                >
                  <div class="form-group col-md-2">
                    <label>Frequency (Sec)</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="ctRate"
                      placeholder="0"
                      [ngClass]="{ 'is-invalid': typesubmit && deviceForm.get('ct.' + i + '.ctRate')?.errors }"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Device Mode</label>
                    <select class="form-control" formControlName="mode">
                      <option value="0" disabled>0 - Undefined</option>
                      <option value="1">1 - 1x Digital Pin Based</option>
                      <option value="2">2 - 2x Digital Pin Based</option>
                      <option value="3">3 - 3x Digital Pin Based</option>
                      <option value="4">4 - CT Based</option>
                      <option value="255">255 - Cloud Based</option>
                      <option value="251">251 - CT WITH VARIANCE THD</option>
                      <option value="252">252 - CT WITH CURRENT THD</option>
                    </select>
                  </div>
                  <div class="form-group col-md-2">
                    <label>Default Cycle Time (sec)</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="actualIdletime"
                      placeholder="0"
                      [ngClass]="{ 'is-invalid': typesubmit && deviceForm.get('ct.' + i + '.actualIdletime')?.errors }"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Upper Control Limit</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="upperLimit"
                      placeholder="0"
                      [ngClass]="{ 'is-invalid': typesubmit && deviceForm.get('ct.' + i + '.upperLimit')?.errors }"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Upper Set Limit</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="upperSet"
                      placeholder="0"
                      [ngClass]="{ 'is-invalid': typesubmit && deviceForm.get('ct.' + i + '.upperSet')?.errors }"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Lower Control Limit</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="lowerLimit"
                      placeholder="0"
                      [ngClass]="{ 'is-invalid': typesubmit && deviceForm.get('ct.' + i + '.lowerLimit')?.errors }"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Lower Set Limit</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="lowerSet"
                      placeholder="0"
                      [ngClass]="{ 'is-invalid': typesubmit && deviceForm.get('ct.' + i + '.lowerSet')?.errors }"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Partcount Pin</label>
                    <select class="form-control" formControlName="ctpartcountPin">
                      <option value="0">0 - Undefined</option>
                      <option value="1">DI1</option>
                      <option value="2">DI2</option>
                      <option value="3">DI3</option>
                      <option value="4">DI4</option>
                      <option value="5">DI5</option>
                      <option value="6">Double</option>
                      <option value="254">Operator By Scanner</option>
                      <option value="255">Cloud Base Derivation</option>
                    </select>
                  </div>
                  <div class="form-group col-md-2">
                    <label>Interlock Status</label>
                    <select class="form-control" formControlName="ctStatus">
                      <option value="1">Interlock Enabled</option>
                      <option value="0">Interlock Disabled</option>
                    </select>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="deviceForm.get('meterSupplier')?.value == 'K2-V1.1'">
              <hr />
              <div class="form-group col-md-6" [hidden]="loginRole == 'CUSTOMER' && deviceForm.get('curSystem')['controls'].length == 0">
                <h4 class="card-title">Current Configuration</h4>
              </div>

              <div formArrayName="curSystem">
                <div
                  class="row"
                  *ngFor="let ct of deviceForm.get('curSystem')['controls']; let i = index"
                  [formGroupName]="i"
                >
                  <div class="form-group col-md-2">
                    <label>Idle Threshold</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="idleTHDmA"
                      placeholder="0"
                      [ngClass]="{ 'is-invalid': typesubmit && deviceForm.get('curSystem.' + i + '.idleTHDmA')?.errors }"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Min Current</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="minValidCurrent"
                      placeholder="0"
                      [ngClass]="{ 'is-invalid': typesubmit && deviceForm.get('curSystem.' + i + '.minValidCurrent')?.errors }"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Max Current</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="maxValidCurrent"
                      placeholder="0"
                      [ngClass]="{ 'is-invalid': typesubmit && deviceForm.get('curSystem.' + i + '.maxValidCurrent')?.errors }"
                    />    
                 </div>
                 <div class="form-group col-md-2">
                    <label>Noise Variance</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="noiseVarienceTHD"
                      placeholder="0"
                      [ngClass]="{ 'is-invalid': typesubmit && deviceForm.get('curSystem.' + i + '.noiseVarienceTHD')?.errors }"
                    />    
                 </div>
                 <div class="form-group col-md-2">
                    <label>State Change Hysteresis</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="stateChangeHystresis"
                      placeholder="0"
                      [ngClass]="{ 'is-invalid': typesubmit && deviceForm.get('curSystem.' + i + '.stateChangeHystresis')?.errors }"
                    />    
                 </div>
                 <div class="form-group col-md-2">
                    <label>Min State Duration</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="minStateDuration"
                      placeholder="0"
                      [ngClass]="{ 'is-invalid': typesubmit && deviceForm.get('curSystem.' + i + '.minStateDuration')?.errors }"
                    />    
                 </div>
                 <div class="form-group col-md-2">
                    <label>Confidence Threshold</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="confidenceTHD"
                      placeholder="0"
                      [ngClass]="{ 'is-invalid': typesubmit && deviceForm.get('curSystem.' + i + '.confidenceTHD')?.errors }"
                    />    
                 </div>
                 <div class="form-group col-md-2">
                    <label>Deviation Range</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="deviationRange"
                      placeholder="0"
                      [ngClass]="{ 'is-invalid': typesubmit && deviceForm.get('curSystem.' + i + '.deviationRange')?.errors }"
                    />    
                 </div>
                 <div class="form-group col-md-2">
                    <label>Pre-Config Cycle Time</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="preConfigCycleTime"
                      placeholder="0"
                      [ngClass]="{ 'is-invalid': typesubmit && deviceForm.get('curSystem.' + i + '.preConfigCycleTime')?.errors }"
                    />    
                 </div>
                 <div class="form-group col-md-2">
                    <label>Sample Window</label>
                    <input
                      type="number"
                      class="form-control"
                      formControlName="sampleWindow"
                      placeholder="0"
                      [ngClass]="{ 'is-invalid': typesubmit && deviceForm.get('curSystem.' + i + '.sampleWindow')?.errors }"
                    />    
                 </div>
              </div>
              </div>
            </ng-container>

            <!-- ─── EMIC Configuration (Wimera-K2 or K2-V1.1) ─── -->
            <ng-container
              *ngIf="
                deviceForm.get('meterSupplier')?.value == 'Wimera-K2' ||
                deviceForm.get('meterSupplier')?.value == 'K2-V1.1'
              "
            >
              <div class="form-group col-md-6">
                <h4 class="card-title">EMIC Configuration</h4>
              </div>
              <div formArrayName="eMICConfig">
                <div
                  class="row"
                  *ngFor="let ct of deviceForm.get('eMICConfig')['controls']; let k = index"
                  [formGroupName]="k"
                >
                  <div class="form-group col-md-3">
                    <label>Name</label>
                    <input type="text" class="form-control" formControlName="eMICName" disabled />
                  </div>

                  <div class="form-group col-md-6">
                    <label>eMIC State</label>

                    <!-- State radio -->
                    <div class="row" *ngIf="ct.get('eMICName')?.value === 'State'">
                      <div *ngFor="let type of Frequency_State; let j = index">
                        <div class="form-check form-check-inline col-md-3">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="eMICType"
                            [id]="'state-' + k + '-' + j"
                            [value]="type.value"
                            (change)="getstatus(type.value)"
                          />
                          <label class="form-check-label" [for]="'state-' + k + '-' + j">{{ type.label }}</label>
                        </div>
                      </div>
                    </div>

                    <!-- Post Frequency input -->
                    <div class="row align-items-center" *ngIf="ct.get('eMICName')?.value === 'Post Frequency'">
                      <div class="col-md-6">
                        <input
                          class="form-control"
                          type="number"
                          formControlName="eMICType"
                          placeholder="Enter value"
                          (input)="onInput($event, k)"
                          [ngClass]="{ 'is-invalid': typesubmit && ct.get('eMICType')?.invalid }"
                        />
                        <div *ngIf="typesubmit && ct.get('eMICType')?.invalid" class="invalid-feedback">
                          This value is required and must be positive.
                        </div>
                      </div>
                    </div>

                    <!-- Frequency radio -->
                    <div class="row" *ngIf="ct.get('eMICName')?.value === 'Frequency'">
                      <div *ngFor="let type of FrequencySequency; let j = index">
                        <div class="form-check form-check-inline col-md-3">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="eMICType"
                            [id]="'freq-' + k + '-' + j"
                            [value]="type"
                          />
                          <label class="form-check-label" [for]="'freq-' + k + '-' + j">{{ type }}</label>
                        </div>
                      </div>
                    </div>

                    <!-- Phase Sequence radio -->
                    <div class="row" *ngIf="ct.get('eMICName')?.value === 'Phase Sequence'">
                      <div *ngFor="let type of phaseSequence; let j = index">
                        <div class="form-check form-check-inline col-md-3">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="eMICType"
                            [id]="'phase-' + k + '-' + j"
                            [value]="type"
                          />
                          <label class="form-check-label" [for]="'phase-' + k + '-' + j">{{ type }}</label>
                        </div>
                      </div>
                    </div>

                    <!-- PGA Gain input -->
                    <div
                      class="row align-items-center"
                      *ngIf="ct.get('eMICName')?.value === 'PGA Gain Configuration'"
                    >
                      <div class="col-md-6">
                        <input
                          class="form-control"
                          type="number"
                          formControlName="eMICType"
                          placeholder="21845"
                          (input)="onInput($event, k)"
                        />
                      </div>
                    </div>

                    <!-- CT Rate radio -->
                    <div class="row" *ngIf="ct.get('eMICName')?.value === 'CT Rate'">
                      <div *ngFor="let type of ctRateSequence; let j = index">
                        <div class="form-check form-check-inline col-md-3">
                          <input
                            class="form-check-input"
                            type="radio"
                            formControlName="eMICType"
                            [id]="'ctrate-' + k + '-' + j"
                            [value]="type.value"
                          />
                          <label class="form-check-label" [for]="'ctrate-' + k + '-' + j">{{ type.label }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- ─── Form Actions ─── -->
            <div class="form-group mt-3">
              <button type="submit" class="btn btn-primary mr-1">
                <span *ngIf="!isEdit">Submit</span>
                <span *ngIf="isEdit">Update</span>
              </button>
              <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- ─── Machine Type Modal ─── -->
  <ng-template #machineType let-modal="close">
    <div class="modal-header">
      <h5 class="modal-title">Machine Type</h5>
      <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body p-3">
      <form (ngSubmit)="saveData()" [formGroup]="machineTypeform" autocomplete="off">
        <div class="form-group">
          <label for="machineType">Machine Type</label>
          <input
            type="text"
            class="form-control"
            id="machineType"
            placeholder="Enter Machine Type"
            formControlName="deviceType"
            [ngClass]="{ 'is-invalid': submit && form.deviceType.errors }"
          />
          <div *ngIf="submit && form.deviceType.errors" class="invalid-feedback">
            <span *ngIf="form.deviceType.errors.required">Machine Type is mandatory.</span>
          </div>
        </div>
        <div class="form-group">
          <label for="description">Description</label>
          <input
            type="text"
            class="form-control"
            id="description"
            placeholder="Enter Description"
            formControlName="description"
            [ngClass]="{ 'is-invalid': submit && form.description.errors }"
          />
          <div *ngIf="submit && form.description.errors" class="invalid-feedback">
            <span *ngIf="form.description.errors.required">Description is mandatory.</span>
          </div>
        </div>
        <div class="text-right">
          <button type="submit" class="btn btn-success">Save</button>
          <button type="button" class="btn btn-danger ml-1" (click)="cancelModal()">Cancel</button>
        </div>
      </form>
    </div>
  </ng-template>

  <!-- ─── Delete Confirmation Modal ─── -->
  <ng-template #deletetemp role="document" let-modal="close">
    <div class="modal-header">
      <h5 class="modal-title">Delete Machine</h5>
      <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body card-body">
      <p>Are you sure you want to delete this machine?</p>
      <button type="button" class="btn btn-danger" (click)="delete(delMachId, deviceId)">Delete</button>
      &nbsp;
      <button type="button" class="btn btn-info" (click)="modal('Cross click')">Cancel</button>
    </div>
  </ng-template>
</div>